import { print } from "graphql";
import { Viproc } from "@/models/viproc";
import { BaseAPI } from "@/api/base.api";
import { Document } from "@/models/document";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map, catchError } from "rxjs/operators";
import GlobalStore from "@/store/modules/global";
import { ProcessoArce } from "@/models/processoArce";

const documento = require("@/query/arproc/Document.graphql");

export class DocumentAPI extends BaseAPI<Document> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/documento`;
  }

  public findByViproc(
    viproc: Viproc,
    recaptcha: string
  ): AxiosObservable<Document> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(documento),
        variables: { inputProcesso: { tipo: "viproc", ...viproc, recaptcha } }
      })
      .pipe(
        map((data: any) => {
          const { documento } = data;
          if (!documento && data.errors && data.errors.length) {
            GlobalStore.setSnackBar({
              message: data.errors[0].exception.message,
              show: true,
              type: "error"
            });
            throw data.errors[0].exception.message;
          }
          return documento;
        })
      );
  }

  public findByNumeroArce(processo: ProcessoArce): AxiosObservable<Document> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(documento),
        variables: { inputProcesso: { tipo: "numero_arce", ...processo } }
      })
      .pipe(
        map((data: any) => {
          const { documento } = data;
          if (!documento && data.errors && data.errors.length) {
            GlobalStore.setSnackBar({
              message: data.errors[0].exception.message,
              show: true,
              type: "error"
            });
            throw data.errors[0].exception.message;
          }
          return documento;
        })
      );
  }
}
